import { tagApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const TAGS_ACTION_TYPE = createNamedActions('systemTags', {
  GET_TAGS: 'GET_TAGS',
  CREATE_TAG: 'CREATE_TAG',
  EDIT_TAG: 'EDIT_TAG',
  DELETE_TAG: 'DELETE_TAG',
});

const tagsSchema = new schema.Entity('data', {}, { idAttribute: 'tagId' });

export const getTagsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await tagApi.getTags(params);

  return dispatch({
    type: TAGS_ACTION_TYPE.GET_TAGS,
    payload: normalize(data, [tagsSchema]).entities.data,
  });
});

export const createTagAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await tagApi.createTag(params);

  return dispatch({
    type: TAGS_ACTION_TYPE.CREATE_TAG,
    payload: data,
  });
});

export const editTagAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await tagApi.editTag(params);

  return dispatch({
    type: TAGS_ACTION_TYPE.EDIT_TAG,
    payload: data,
  });
});

export const deleteTagAction = params => async dispatch => {
  const { data } = await tagApi.deleteTag(params);

  return dispatch({
    type: TAGS_ACTION_TYPE.DELETE_TAG,
    payload: data,
    meta: params,
  });
};
